module.exports = __webpack_public_path__ + "img/mortar-pestle.325431b8.svg";